module.exports = __webpack_public_path__ + "img/service.67434b04.png";